import styled from 'styled-components';
import {TWO_LINES_TITLE} from '../../../css-constants';
import {styledByDevice} from '../../../../../themes/architecture/styled-by-device';

//.games-item-title
const DefaultBox = styled.div`
    color: ${props => props.theme.colors.bodyText};
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    margin: auto;
    text-align: center;
    opacity: 1;
    font-weight: 300;
    line-height: normal;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    direction: initial;

`;

export const PcBox = styled(DefaultBox)`
    font-size: 1.4rem;

`;

export const MobileBox = styled(DefaultBox)`
    font-size: 1.2rem;
    padding-bottom: 0;


     &.${TWO_LINES_TITLE} {
        max-width: 90%;
        white-space: initial;
    }

    @media ${({theme}) => theme.mediaQuery.sAndBelow} {
        font-size: 0.9rem;
    }
`;

export const GameTitleDefaultBox =  styledByDevice(PcBox, MobileBox);